// Node
import {BONUSES_FOR_REVIEW} from "../../../common/camps/show/utils";

const $ = require('jquery');

const setNavElementEvents = function (navElements, activeSelector) {
  navElements
    .forEach(function (navElement) {
      return navElement
        .querySelector('a')
        .addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          document
            .getElementById(navElement.dataset.section)
            .scrollIntoView({behavior: 'smooth'});

          document
            .querySelectorAll(`.${activeSelector}`)
            .forEach(function (element) {
              element.classList.remove(activeSelector);
            });

          navElement.classList.add(activeSelector);
        });
    });
};

const setNavElementEventsWithFixHeader = function (navElements, activeSelector, fixHeader) {
  for (let i = 0; i < navElements.length; i++) {
    const navElement = navElements[i];
    $(navElement).find('a').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const targetSection = $('#' + $(navElement).data('section'))[0];
      const headerHeight = fixHeader.outerHeight();
      const navHeight = fixHeader.hasClass('fix-nav') ? headerHeight - 5 : headerHeight * 2 - 5;
      let topPosition;
      topPosition = $(targetSection).offset().top - navHeight;

      window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
      });

      $('.' + activeSelector).removeClass(activeSelector);
      $(navElement).addClass(activeSelector);
    });
  }
};

const fixBaseMenu = function (additionalHeight = 0) {
  let nav = $('.page-nav'),
    navContainer = $('.nav-list'),
    button = $('.page-nav__buttons'),
    positionX = nav.offset(),
    screenPosition = $(window).scrollTop();
  if (nav.length > 0) {
    let isPlaceholderSet = false;
    $(window)
      .scroll(function () {
        if ($(this)
          .scrollTop() > positionX.top - additionalHeight) {
          nav.addClass("fix-nav");
          navContainer.addClass("container");
          button.addClass("fix-btn");

          $('.bonuses__checklist').hide();
          if (($('#marker-left').text() !== BONUSES_FOR_REVIEW.toString())) {
            $('.bonuses__checklist-short').show();
          } else {
            $('.review-progress.page-nav-placeholder').css('height', '67px');
          }

          if (!isPlaceholderSet) {
            $('.page-nav-placeholder').show();
            isPlaceholderSet = true;
          }
        } else {
          nav.removeClass("fix-nav");
          navContainer.removeClass("nav-container");
          button.removeClass("fix-btn");
          $('.page-nav-placeholder').hide();
          isPlaceholderSet = false;

          $('.bonuses__checklist-short').hide();
          if (($('#marker-left').text() !== BONUSES_FOR_REVIEW.toString())) {
            $('.bonuses__checklist').show();
          }

          $('.review-progress.page-nav-placeholder').css('height', '115px');
        }
      });
    if (screenPosition > positionX.top) {
      nav.addClass("fix-nav");
      navContainer.addClass("nav-container");
      button.addClass("fix-btn");
    } else {
      navContainer.removeClass("nav-container");
    }
  }
};

const setActiveTab = function () {
  $(document).ready(function () {
    function activateTab(section) {
      $('.page-tabs__tab').removeClass('popup-tabs__tab-active');
      $(`.page-nav__list-item[data-section="${section}"] .page-tabs__tab`).addClass('popup-tabs__tab-active');
    }

    function updateActiveTabOnScroll() {
      const navHeight = $('.page-nav').outerHeight();
      const scrollPosition = $(window).scrollTop() + navHeight;

      $('.page-nav__list-item').each(function () {
        const section = $(this).data('section');
        const target = $('#' + section);
        if (!target.length) return;

        if (target.position().top <= scrollPosition && (target.position().top + target.outerHeight()) >= scrollPosition) {
          activateTab(section);
        } else if (scrollPosition < $('.page-nav__list-item[data-section="details"]').position()?.top) {
          $('.page-nav__list-item[data-section="details"] .popup-tabs__tab').addClass('popup-tabs__tab-active');
        }

        if (!$('.page-nav').hasClass('fix-nav')) {
          $('.page-nav__list-item[data-section="details"] .popup-tabs__tab').addClass('popup-tabs__tab-active');
        }
      });
    }

    updateActiveTabOnScroll();

    $(window).scroll(updateActiveTabOnScroll);
  });
};

export {
  setNavElementEvents,
  fixBaseMenu,
  setActiveTab,
  setNavElementEventsWithFixHeader
};
